import React, { Component } from 'react';
import {
  Row, Col, Button, Card, CardBody, Label
} from 'reactstrap';
import { connect } from 'react-redux';
import Sidebar from 'react-sidebar';
import swal from 'sweetalert';
import Ionicon from 'react-ionicons';
import { uuid } from 'uuidv4';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// components
// import EditFleetDetail from '../../components/EditFleetDetail/EditFleetDetail';
import ListSubsidiaries from '../../components/ListSubsidiaries/ListSubsidiaries';
import AddEditSubsidiaries from '../../components/AddEditSubsidiaries/AddEditSubsidiaries';
// services
import UserService from '../../services/UserService';
// import Validation from '../../services/Validation';
import { messages } from '../../constants/constant.message';
import AddEditSubsidiariesService from '../../services/AddEditSubsidiariesService';

// actions
import { setUserDetail, isProfileUpdate } from '../../actions/UserAction';

// css
import '../Profile/Profile.css';
import FleetService from '../../services/FleetService';
import FleetRegistration from '../../components/FleetRegistration/FleetRegistration';
import NewFleetBusinessDetail from '../../components/NewFleetBusinessDetail/NewFleetBusinessDetail';
import NewFleetPrimaryContactDetail from '../../components/NewFleetPrimaryContactDetail/NewFleetPrimaryContactDetail';
import NewFleetPersonalDetails from '../../components/NewFleetPersonalDetails/NewFleetPersonalDetails';

import './EnrollNewFleet.css';
// import NewFleetBusinessRelatedDetails from '../../components/NewFleetBusinessRelatedDetails/NewFleetBusinessRelatedDetails';
import NewFleetService from '../../services/NewFleetService';
import ModalService from '../../services/ModalService';
import Storage from '../../services/Storage';
import CustomSpinner from '../../components/CustomSpinner/CustomSpinner';
import AuthService from '../../services/AuthService';
import InviteFleet from '../../components/InviteFleet/InviteFleet';
import * as Scroll from 'react-scroll';
import VehicleCountDeatil from '../../components/VehicleCountDeatil/VehicleCountDeatil';
import AddEditFleetVehicle from '../../components/AddEditFleetVehicle/AddEditFleetVehicle';
// import VehicleDetail from '../../components/VehicleDetail/VehicleDetail';
import NewFleetCommunicationDetail from '../../components/NewFleetCommunicationDetail/NewFleetCommunicationDetail';
import { Roles } from '../../constants/constant.role';
class EnrollNewFleet extends Component {

  addEditSubsidiariesArr = [];

  isListSubsidiaries = false;


  constructor(props) {
    super(props);
    this.state = {
      uuid: uuid(),
      //uuid: '663b4ec5-20d7-4e14-a248-2c39b1459b25',
      region_id: null,
      fleet_manager: null,
      fleet_manager_name: null,
      userDetail: Storage.getUserDetail(),
      isFleeData: false,
      showBuildMyFleet: false,
      editSubsidiariesIndex: 0,
      isAddSubsidiaries: true,
      sidebarOpen: false,
      profileImage: null,
      sapId: null,
      businessName: null,
      ownerName: null,
      address: null,
      isUpdateProfileRequestSend: true,
      isNotAddEditSubsidaries: false,
      isLogin: AuthService.isAuthenticated(),
      isBusinessEditActive: false,
      isContactEditActive: false,
      isSocialEditActive: false,
      isImageUpdating: false,
      isOpenAddEditVehicle: false,
      isAddVehicleDetail: false,
      controls: {
        is_prospective: {
          value: false,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        truck: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        bus: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        scv: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        lcv: {
          value: null,
          valid: true,
          touched: false,
          required: true,
          showErrorMsg: false,
          isEditActive: false
        },
        profile_picture: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        selfie_with_fleet_owner: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
          isUploadedImage: false
        },
        fleet_office_inside_photo: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
          isUploadedImage: false
        },
        fleet_office_outside_photo: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false,
          isUploadedImage: false
        },
      },
      fleetByIdData: {
        is_draft: true
      },
      birthDate: null,
      anniversaryDate: null,
      isListSubsidiaries: false,
      activeFragment: null,
      isBusinessFormValid: false,
      isContactFormValid: false,
      isSocialFormValid: false,
      salesManagerData: [],
      areaSalesManagerData: [],
      depotData: [],
      isValidForm: false,
      isLoading: false,
      vehicleData: {},
      fleetData: [],
      business_related_detail_data: {}
    }
    this.stateAddEditSubsidiaries = {
      addEditSubsidiaries: [],
    };

    this.childNewFleetBusinessDetail = React.createRef();
    this.childNewFleetPrimaryContactDetail = React.createRef();
    this.childNewFleetPersonalDetails = React.createRef();
    this.childNewFleetCommunicationDetail = React.createRef();
    this.childNewFleetBusinessRelatedDetails = React.createRef();
    if (this.state.userDetail && Object.keys(this.state.userDetail).length <= 0 || !this.state.userDetail) {
      this.props.history.push('/login');
    }
  }

  clearLocalData = () => {
    AuthService.logout();
    //this.props.setUserDetail(null);
    // this.closeLogoutModal();
    this.props.history.replace("/login");
    // this.setState({ redirectToLoginPage: true });
  }



  dynamicAddEditSubsidiaries = () => {
    this.stateAddEditSubsidiaries.addEditSubsidiaries.push(
      Object.assign({}, {
        controls: {
          id: '',
          uuid: '',
          pin_code: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'pin_code'
          },
          sap_id: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'sap_id'
          },
          subsidiaryName: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'subsidiaryName'
          },
          address1: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'address_1'
          },
          address2: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'address_2'
          },
          state: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'state_id'
          },
          city: {
            value: '',
            valid: null,
            touched: false,
            message: null,
            nullValue: null,
            invalidFirstname: null,
            databaseFieldName: 'city_id'
          },
          gst: {
            value: '',
            valid: true,
            touched: false,
            required: false,
            invalidLength: null,
            showErrorMsg: false,
            databaseFieldName: 'gst_number'
          },
          pan: {
            value: '',
            valid: true,
            required: false,
            touched: false,
            invalidLength: null,
            showErrorMsg: false,
            databaseFieldName: 'pan_number'
          }
        },
        isValidForm: false
      })
    );
  }

  getNewFleetsById = (id) => {
    this.setState({
      isLoading: true
    })
    NewFleetService.getNewFleetById(id)
      .then(res => {
        let { controls } = this.state;
        if (res.data.data && Object.keys(res.data.data).length > 0) {
          controls.profile_picture.value = res.data.data.profile_picture;
          controls.selfie_with_fleet_owner.value = res.data.data.selfie_with_fleet_owner;
          controls.fleet_office_inside_photo.value = res.data.data.fleet_office_inside_photo;
          controls.fleet_office_outside_photo.value = res.data.data.fleet_office_outside_photo;
          this.setState({
            controls: controls,
            fleetByIdData: res.data.data,
            uuid: res.data.data.uuid,
            fleet_manager_name: res.data.data.fleet_manager_name,
            fleet_manager: res.data.data.fleet_manager,
            region_id: res.data.data.region,
            isLoading: false
          });
          this.setFleetDetail();

          // setTimeout(() => {
          //   if (this.childNewFleetDetail.current) {
          //     this.childNewFleetDetail.current.setFleetData();
          //     this.getFleetData();
          //     this.getSubsidiaries();
          //   }
          // }, 500);
          // if (Object.keys(res.data.data).length > 0) {
          //   this.openSidebarFleetDetail();
          // }
        } else {
          this.setState({
            fleetByIdData: {},
            isLoading: false
          })
        }
      })
      .catch(e => {
        this.setState({
          isLoading: false
        })
      });
  }


  deleteFleet = async (fleetId, totalTyre, vehicle_type) => {
    try {
      this.setState({ isLoading: true });
      const { data } = await FleetService.deleteFleet({ fleetId, totalTyre }, this.state.uuid ? this.state.uuid : null);
      if (data.message) {
        this.getFleetData();
        this.getBusinessRelatedDetail();
        ModalService.openAlert(data.message, '', 'success');
        this.getFleetData();
      }
      this.setState({ isLoading: false });
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
        ModalService.openAlert(e.response.data.error[0].message, '', 'error');
      }
      this.setState({ isLoading: false });
      console.log(e);
    }
  }

  deleteFleetVehicle = (vehicle_type) => {
    swal({
      title: "",
      text: "Are you sure, you want to delete vehicle detail ?",
      icon: "warning",
      buttons: ["No", "Yes"]
    }).then(isConfirm => {
      if (isConfirm) {
        let { fleetData } = this.state;
        let index = fleetData.findIndex(element => element.type.toLowerCase() === vehicle_type);
        if (index > -1) {
          this.deleteFleet(fleetData[index].data[0].fleet_id, fleetData[index].data[0].total_tyre, vehicle_type);
        }
      }
    });
  }

  async getBusinessRelatedDetail() {
    let { business_related_detail_data } = this.state;
    try {
      const { data } = await FleetService.getBusinessRelatedDetails(this.state.uuid);
      if (data.data && Object.keys(data.data).length > 0) {
        business_related_detail_data = data.data;
      } else {
        business_related_detail_data = {};
      }
      if (this.refs.refVehicleDetail) {
        this.refs.refVehicleDetail.setFleetDetail(business_related_detail_data);
      }
      this.setState({
        business_related_detail_data
      })
    } catch (error) {
      console.log(error);
    }

  }
  async getFleetData() {
    let { fleetData } = this.state;
    try {
      this.setState({
        isLoading: true
      })
      const { data } = await FleetService.getFleetData(this.state.uuid);
      if (data) {
        fleetData = data.data;
        this.setState({ fleetData: data.data });
        // let businessRelatedDetail = {
        //   truck: [],
        //   bus: [],
        //   lcv: [],
        //   scv: [],
        //   icv: [],
        //   pickup: []
        // };

        let totalCountBus = 0, totalCountTruck = 0, totalCountLcv = 0,
          totalCountScv = 0, totalCountIcv = 0, totalCountPickup = 0, totalCountRetread = false,
          totalWheelTruck = 0,
          totalWheelBus = 0,
          totalWheelSCV = 0,
          totalWheelLCV = 0,
          totalWheelICV = 0,
          totalWheelPickup = 0;
        data.data.forEach(element => {
          let count = 0;
          if (element.type.toLowerCase() === 'retread') {
            count = element.data[0].number_of_tyres_vehicle_count.tyres_per_month;
          }
          if (element.type.toLowerCase() === 'truck') {
            totalCountTruck = element.total_vehical;
            totalWheelTruck = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'bus') {
            totalCountBus = element.total_vehical;
            totalWheelBus = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'scv') {
            totalCountScv = element.total_vehical;
            totalWheelSCV = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'lcv') {
            totalCountLcv = element.total_vehical;
            totalWheelLCV = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'icv') {
            totalCountIcv = element.total_vehical;
            totalWheelICV = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'pickup') {
            totalCountPickup = element.total_vehical;
            totalWheelPickup = element.data[0].total_tyre;
          }
          if (element.type.toLowerCase() === 'retread') {
            totalCountRetread = true;
          }
        });
        this.refs.refCountVehicleDetail.setData({
          totalCountBus: totalCountBus,
          totalCountTruck: totalCountTruck,
          totalCountLcv: totalCountLcv,
          totalCountScv: totalCountScv,
          totalCountIcv: totalCountIcv,
          totalCountPickup: totalCountPickup,
          totalCountRetread: totalCountRetread,
          totalWheelTruck: totalWheelTruck,
          totalWheelBus: totalWheelBus,
          totalWheelSCV: totalWheelSCV,
          totalWheelLCV: totalWheelLCV,
          totalWheelICV: totalWheelICV,
          totalWheelPickup: totalWheelPickup,
        });
        this.refs.refVehicleDetail.setData({
          totalCountBus: totalCountBus,
          totalCountTruck: totalCountTruck,
          totalCountLcv: totalCountLcv,
          totalCountScv: totalCountScv,
          totalCountIcv: totalCountIcv,
          totalCountPickup: totalCountPickup,
          totalCountRetread: totalCountRetread,
          totalWheelTruck: totalWheelTruck,
          totalWheelBus: totalWheelBus,
          totalWheelSCV: totalWheelSCV,
          totalWheelLCV: totalWheelLCV,
          totalWheelICV: totalWheelICV,
          totalWheelPickup: totalWheelPickup,
        });
      }
      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({
        isLoading: false
      })
      console.log(error);
    }
  }

  componentDidMount() {

    if (this.state.userDetail && Object.keys(this.state.userDetail).length <= 0 || !this.state.userDetail) {
      this.props.history.push('/login');
    }
    window.addEventListener('resize', this.resizeWindow);
    const searchParam = this.props.location.search;
    if (searchParam) {
      const keys = searchParam.split('&');
      const idString = keys[0];
      if (idString) {
        const id = idString.split('=');
        this.getNewFleetsById(id[1]);
        return
      }
    }
    if (this.state.userDetail && this.state.userDetail.temp_fleet) {
      this.getInvitedFleetByNumber()
    } else {
      this.setState({
        fleet_manager_name: this.state.userDetail && this.state.userDetail.owner_name ? this.state.userDetail.owner_name : null,
        fleet_manager: this.state.uuid,
        region_id: this.state.userDetail && this.state.userDetail.region_id ? this.state.userDetail.region_id : null,
      })
      this.getSubsidiaries();
      this.getFleetData();
      this.getBusinessRelatedDetail();
      this.getAMSM();
      this.getDepot();
      // this.getFleetData();
    }
  }

  setFleetDetail = () => {

    if (this.childNewFleetBusinessDetail.current) {
      this.childNewFleetBusinessDetail.current.setFleetDetail();
    }
    if (this.childNewFleetPrimaryContactDetail.current) {
      this.childNewFleetPrimaryContactDetail.current.setFleetDetail();
    }
    if (this.childNewFleetBusinessRelatedDetails.current) {
      this.childNewFleetBusinessRelatedDetails.current.setFleetDetail();
    }
    if (this.childNewFleetPersonalDetails.current) {
      this.childNewFleetPersonalDetails.current.setFleetDetail();
    }
    if (this.childNewFleetCommunicationDetail.current) {
      this.childNewFleetCommunicationDetail.current.setFleetDetail();
    }

    // if (this.refs.refVehicleDetail) {
    //   this.refs.refVehicleDetail.setFleetDetail();
    // }
    this.getSubsidiaries();
    this.getFleetData();
    this.getBusinessRelatedDetail();
    this.getAMSM();
    this.getDepot();

  }

  getInvitedFleetByNumber = () => {
    if (this.state.userDetail && !this.state.userDetail.mobile_number) {
      return
    }
    let obj = {
      mobile_number: this.state.userDetail.mobile_number
    }
    NewFleetService.getInvitedFleetByNumber(obj)
      .then(res => {
        let { controls } = this.state;
        if (res.data.data && Object.keys(res.data.data).length > 0) {
          controls.profile_picture.value = res.data.data.profile_picture;
          controls.selfie_with_fleet_owner.value = res.data.data.selfie_with_fleet_owner;
          controls.fleet_office_inside_photo.value = res.data.data.fleet_office_inside_photo;
          controls.fleet_office_outside_photo.value = res.data.data.fleet_office_outside_photo;
          this.setState({
            fleetByIdData: res.data.data,
            uuid: res.data.data.uuid,
            fleet_manager_name: res.data.data.fleet_manager_name,
            fleet_manager: res.data.data.fleet_manager,
            region_id: res.data.data.region,
            controls
          }, () => {
            this.setFleetDetail();
          });
        }
      })
      .catch(e => {
        console.error('e', e);
      });
  }


  componentWillUnmount() {
    document.body.style.overflow = 'auto';
    if (this.state.userDetail && this.state.userDetail.temp_fleet) {
      this.clearLocalData();
    }
    window.removeEventListener('resize', this.resizeWindow);
  }

  resizeWindow = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }



  getSubsidiaries() {
    AddEditSubsidiariesService.getSubsidiaries(this.state.uuid)
      .then(response => {
        let isDisplayedSubsidiariesConfirmModal = false;
        if (response.data && response.data.data && response.data.data.length > 0) {
          this.stateAddEditSubsidiaries.addEditSubsidiaries = [];
          response.data.data.forEach(element => {
            this.dynamicAddEditSubsidiaries();
          });
          this.isListSubsidiaries = true;
          response.data.data.forEach((element, i) => {
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.sap_id.value = element.sap_id;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.address1.value = element.address_1;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.address2.value = element.address_2;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.city.value = element.city_name;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.gst.value = element.gst_number;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.pan.value = element.pan_number;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.state.value = element.state_name;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.subsidiaryName.value = element.subsidiary_name;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.id = element.id;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.uuid = element.uuid;
            this.stateAddEditSubsidiaries.addEditSubsidiaries[i].controls.pin_code.value = element.pin_code;
          });
          isDisplayedSubsidiariesConfirmModal = true;
          this.setState({ isListSubsidiaries: true });
        } else {
          this.stateAddEditSubsidiaries.addEditSubsidiaries = [];
          this.setState({ isListSubsidiaries: false });
        }
        this.setState(prevState => ({
          ...prevState,
          isDisplayedSubsidiariesConfirmModal
        }));
      })
      .catch(e => {
        console.error('e', e);
      });
  }



  uploadFleetDoc = (event, type) => {
    // if (this.state.fleetByIdData && !this.state.fleetByIdData.is_draft) {
    //   return
    // }
    const file = event.target.files[0];
    this.setState({ isLoading: true });
    const obj = {
      file
    };
    let { controls } = this.state;
    NewFleetService.uploadFleetDoc(obj, 'profile')
      .then(res => {
        if (res.data) {
          if (type === 'fileInputUploadSelfie') {
            controls.selfie_with_fleet_owner.value = res.data.data.imageUrl;
            controls.selfie_with_fleet_owner.showErrorMsg = false;
            controls.selfie_with_fleet_owner.isUploadedImage = true;
            if (this.fileInputUploadSelfie) {
              this.fileInputUploadSelfie.value = "";
            }
          } else if (type === 'fileInputUploadFleetOfficeInside') {
            controls.fleet_office_inside_photo.value = res.data.data.imageUrl;
            controls.fleet_office_inside_photo.isUploadedImage = true;
            controls.fleet_office_inside_photo.showErrorMsg = false;
            if (this.fileInputUploadFleetOfficeInside) {
              this.fileInputUploadFleetOfficeInside.value = "";
            }
          } else if (type === 'fileInputUploadFleetOficeOuside') {
            controls.fleet_office_outside_photo.value = res.data.data.imageUrl;
            controls.fleet_office_outside_photo.isUploadedImage = true;
            controls.fleet_office_outside_photo.showErrorMsg = false;
            if (this.fileInputUploadFleetOficeOuside) {
              this.fileInputUploadFleetOficeOuside.value = "";
            }
          } else if (type === 'profile') {
            controls.profile_picture.value = res.data.data.imageUrl;
          }
          this.setState({
            controls,
            isLoading: false
          });
        }
      })
      .catch(e => {
        if (type === 'fileInputUploadSelfie') {
          controls.selfie_with_fleet_owner.showErrorMsg = true;
          controls.selfie_with_fleet_owner.isUploadedImage = false;
        } else if (type === 'fileInputUploadFleetOfficeInside') {
          controls.fleet_office_inside_photo.showErrorMsg = true;
          controls.fleet_office_inside_photo.isUploadedImage = false;
        } else if (type === 'fileInputUploadFleetOficeOuside') {
          controls.fleet_office_outside_photo.showErrorMsg = true;
          controls.fleet_office_outside_photo.isUploadedImage = false;
        }
        this.setState({
          controls,
          isLoading: false
        });
      });
  }

  activeFragment = (fragment) => {
    this.setState({ activeFragment: fragment });
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    controls[controlName].touched = true;
    this.setState({ controls });
    // this.handleValidation();

  }

  handleValidation = (isSubmit = false) => {
    let { controls, isValidForm } = this.state;
    let { selfie_with_fleet_owner, fleet_office_inside_photo, fleet_office_outside_photo } = controls;
    if (this.state.userDetail && this.state.userDetail.temp_fleet) {
      this.setState({ controls, isValidForm: true });
      return true;
    }
    // if (this.state.userDetail && !this.state.userDetail.temp_fleet) {
    //   if (selfie_with_fleet_owner.touched === true || isSubmit) {
    //     selfie_with_fleet_owner = Validation.notNullValidator(selfie_with_fleet_owner);
    //     selfie_with_fleet_owner.valid = !(selfie_with_fleet_owner.nullValue);
    //     if (selfie_with_fleet_owner.valid === false) {
    //       selfie_with_fleet_owner.showErrorMsg = true;
    //     } else {
    //       selfie_with_fleet_owner.showErrorMsg = false;
    //     }
    //   }
    // }

    // if (fleet_office_inside_photo.touched === true || isSubmit) {
    //   fleet_office_inside_photo = Validation.notNullValidator(fleet_office_inside_photo);
    //   fleet_office_inside_photo.valid = !(fleet_office_inside_photo.nullValue);
    //   if (fleet_office_inside_photo.valid === false) {
    //     fleet_office_inside_photo.showErrorMsg = true;
    //   } else {
    //     fleet_office_inside_photo.showErrorMsg = false;
    //   }
    // }

    // if (fleet_office_outside_photo.touched === true || isSubmit) {
    //   fleet_office_outside_photo = Validation.notNullValidator(fleet_office_outside_photo);
    //   fleet_office_outside_photo.valid = !(fleet_office_outside_photo.nullValue);
    //   if (fleet_office_outside_photo.valid === false) {
    //     fleet_office_outside_photo.showErrorMsg = true;
    //   } else {
    //     fleet_office_outside_photo.showErrorMsg = false;
    //   }
    // }
    fleet_office_inside_photo.valid = true;
    fleet_office_outside_photo.valid = true;
    selfie_with_fleet_owner.valid = true;
    isValidForm = true;

    // if ((selfie_with_fleet_owner.valid === true && this.state.userDetail && !this.state.userDetail.temp_fleet) &&
    //   fleet_office_inside_photo.valid === true &&
    //   fleet_office_outside_photo.valid === true) {
    //   isValidForm = true;
    // } else {
    //   isValidForm = false;
    // }


    this.setState({ controls, isValidForm });
    return isValidForm;

  }


  handleFleetSave = (inputName) => {
    const { controls } = this.state;
    // const { birthDate, anniversaryDate, facebook, instagram, website } = controls;
    // const arr = socialCardObj.fields;
    const obj = {};
    obj[inputName] = controls[inputName].value;

    UserService.updateUserInfo(obj)
      .then(data => {
        const userData = data.data.data;
        this.props.setUserDetail(userData);
        this.makeEditActiveFleet(inputName, false);
        // this.setState({ socialCardObj, isSocialEditActive: false, aDayMaster, bDayMaster });
      })
      .catch(e => {

      });
  }


  makeEditActiveFleet = (controlName, value) => {
    const { controls } = this.state;
    controls[controlName].isEditActive = value;
    this.setState({ controls });
  }

  onSetSidebarOpen = (open) => {
    document.body.style.overflow = 'hidden';
    this.dynamicAddEditSubsidiaries();
    this.setState((prevState) => {
      return {
        ...prevState,
        isDisplaySubsidiariesConfirmModal: true,
        sidebarOpen: open,
        isAddSubsidiaries: true,
        editSubsidiariesIndex: this.stateAddEditSubsidiaries.addEditSubsidiaries.length - 1
      };
    });
    setTimeout(() => {
      if (Object.keys(this.refs).length > 0 && this.refs && this.refs.childAddEditSubsidiaries) {
        this.refs.childAddEditSubsidiaries.setValue();
      }
    }, 1);
  }

  removeSubsidiaries = (id) => {
    AddEditSubsidiariesService.deleteSubsidiaries({ id }, this.state.uuid)
      .then(response => {
        // debugger;
        document.body.style.overflow = 'auto';
        swal('Deleted Subsidiary', messages.ADD_EDIT_SUBSIDIARIES.SUCCESS_DELETED_SUBSIDIARIES, 'success');
        this.getSubsidiaries();
      })
      .catch(e => {
        if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
          swal('', e.response.data.error[0].message, 'error');
        }
      });
  }

  editSubsidiaries = (index, display = false) => {
    this.setState((prevState) => {
      return {
        ...prevState, sidebarOpen: true, editSubsidiariesIndex: index, isAddSubsidiaries: false,
        isNotAddEditSubsidaries: display
      };
    });
    setTimeout(() => {
      if (Object.keys(this.refs).length > 0 && this.refs && this.refs.childAddEditSubsidiaries) {
        this.refs.childAddEditSubsidiaries.setEditData(index, display);
      }
    }, 1);
  }

  onCloseSidebar = () => {
    document.body.style.overflow = 'auto';
    this.getSubsidiaries();
    this.setState((prevState) => {
      return { ...prevState, sidebarOpen: false };
    });
  }


  addSubsidiaries = () => {
    this.getSubsidiaries();
    this.onCloseSidebar();
    setTimeout(() => {
      this.scrollTo('list-subsidiaries');
    }, 500);
  }

  buildMyFleetClick = (flag) => {
    if (!flag) {
      this.getFleetData();
      setTimeout(() => {
        this.scrollTo('build-my-fleet');
      }, 500);
    }
    this.setState({ showBuildMyFleet: flag });
  }

  setBuinesssDetailFromInviteFleet = (data) => {
    if (this.childNewFleetBusinessDetail.current) {
      this.childNewFleetBusinessDetail.current.setBuinesssDetailFromInviteFleet(data);
    }
  }


  // async getFleetData() {
  //   try {
  //     let { isFleeData } = this.state;
  //     const { data } = await FleetService.getFleetData(this.state.uuid);
  //     isFleeData = false;
  //     let { controls } = this.state;
  //     if (data && data.data.length > 0) {
  //       isFleeData = true;
  //       data.data.forEach(element => {
  //         let value = 0;
  //         if (element.type === 'Truck' || element.type === 'truck') {
  //           element.data.forEach((truckdata, i) => {
  //             if (element.data[i].number_of_tyres_vehicle_count) {
  //               Object.keys(element.data[i].number_of_tyres_vehicle_count).forEach(function (item) {
  //                 value += element.data[i].number_of_tyres_vehicle_count[item];
  //               });
  //             }
  //           });
  //           controls.truck.value = value;
  //         }
  //         if (element.type === 'Bus' || element.type === 'bus') {
  //           element.data.forEach((busdata, i) => {
  //             if (element.data[i].number_of_tyres_vehicle_count) {
  //               Object.keys(element.data[i].number_of_tyres_vehicle_count).forEach(function (item) {
  //                 value += element.data[i].number_of_tyres_vehicle_count[item];
  //               });
  //             }
  //           });
  //           controls.bus.value = value;
  //         }
  //       });
  //       let isCheckBus = data.data.findIndex((element) => element.type === 'Bus' || element.type === 'bus');
  //       let isCheckTruck = data.data.findIndex((element) => element.type === 'Truck' || element.type === 'truck');
  //       if (isCheckBus <= -1) {
  //         controls.bus.value = '';
  //       }
  //       if (isCheckTruck <= -1) {
  //         controls.truck.value = '';
  //       }
  //     }
  //     this.setState((prevState) => {
  //       return { ...prevState, isFleeData, controls };
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  updateTruckBusData = (params) => {
    const { controls } = this.state;
    const { truck, bus } = controls;
    truck.value = params.truck.value;
    bus.value = params.bus.value;
    this.setState({ controls });
  }

  updateBusinessRelatedData = (reqData) => {

    NewFleetService.editBusinessRelatedDetail(reqData)
      .then(data => {
        let { fleetByIdData } = this.state;
        if (data.message) {
          fleetByIdData.business_related_detail = reqData.business_related_detail;
          this.setState({ isLoading: false, fleetByIdData },
            () => {
              if (this.refs.refVehicleDetail) {
                this.refs.refVehicleDetail.setFleetDetail();
              }
            });
        }
      })
      .catch(e => {

        this.setState({ isLoading: false });
      });
  }


  updateFleetData = (reqData) => {
    this.setState({ isLoading: true });
    NewFleetService.editInviteFleet(reqData)
      .then(data => {
        if (data.data) {
          swal({
            title: '',
            text: data.data.message,
            icon: 'success',
            type: 'success',
          }).then(value => {
            if (this.state.userDetail && !this.state.userDetail.temp_fleet) {
              this.redirectToOnFleetReg();
            } else {
              AuthService.logout();
              this.props.history.push('/login');
            }

          });
        }
        this.setState({ isLoading: false });
      })
      .catch(e => {
        if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
          ModalService.openAlert(e.response.data.error[0].message, '', 'error');
        }
        this.setState({ isLoading: false });
      });
  }

  getReqData = (is_draft = true) => {
    let controlsNewFleetBusinessDetail = this.childNewFleetBusinessDetail.current.state.controls;
    let controlsNewFleetPrimaryContactDetail = this.childNewFleetPrimaryContactDetail.current.state.controls;
    let controlsNewFleetPersonalDetails = this.childNewFleetPersonalDetails.current.state.controls;
    let controlsNewFleetCommunicationDetail = this.childNewFleetCommunicationDetail.current.state.controls;
    let { controls, salesManagerData } = this.state;
    let reqData = {
      "temp_id": this.state.uuid,
      "company_name": controlsNewFleetBusinessDetail.company_name.value,
      "company_type": controlsNewFleetBusinessDetail.company_type.value,
      "owner_name": controlsNewFleetBusinessDetail.owner_name.value,
      "designation": controlsNewFleetBusinessDetail.designation.value,
      "mobile_number": controlsNewFleetBusinessDetail.mobile_number.value,
      "phone_number": controlsNewFleetBusinessDetail.phone_number.value,
      "whatsapp_number": controlsNewFleetBusinessDetail.whatsapp_number.value,
      "email": controlsNewFleetBusinessDetail.email.value,
      "website": controlsNewFleetBusinessDetail.website.value,
      "address": controlsNewFleetBusinessDetail.address.value,
      "city": controlsNewFleetBusinessDetail.city.value,
      "state": controlsNewFleetBusinessDetail.state.value,
      "pin_code": controlsNewFleetBusinessDetail.pin_code.value,
      "pan_number": controlsNewFleetBusinessDetail.pan_number.value,
      "gst_number": controlsNewFleetBusinessDetail.gst_number.value,
      "fleet_manager": this.state.userDetail.uuid,
      "depot": controlsNewFleetBusinessDetail.depot.value,
      "region": this.state.region_id,
      "sales_officer": controlsNewFleetBusinessDetail.sales_officer.value,
      "sales_manager": salesManagerData.length > 0 ? salesManagerData[0].uuid : '',
      "area_sales_manager": controlsNewFleetBusinessDetail.area_sales_manager.value,
      "enrollment_type": controlsNewFleetBusinessDetail.enrollment_type.value,
      "primary_contact_person": controlsNewFleetPrimaryContactDetail.primary_contact_person.value,
      "primary_contact_designation": controlsNewFleetPrimaryContactDetail.primary_contact_designation.value,
      "primary_mobile_number": controlsNewFleetPrimaryContactDetail.primary_mobile_number.value,
      "primary_whatsapp_number": controlsNewFleetPrimaryContactDetail.primary_whatsapp_number.value,
      "primary_email": controlsNewFleetPrimaryContactDetail.primary_email.value,
      "home_address": controlsNewFleetPersonalDetails.home_address.value,
      "birth_date": controlsNewFleetPersonalDetails.birth_date.value,
      "education_qualification": controlsNewFleetPersonalDetails.education_qualification.value,
      "languages": [],
      "marital_status": controlsNewFleetPersonalDetails.marital_status.value === 'married' ? true : false,
      "anniversary_date": controlsNewFleetPersonalDetails.anniversary_date.value,
      "spouse_name": controlsNewFleetPersonalDetails.spouse_name.value,
      "spouse_dob": controlsNewFleetPersonalDetails.spouse_dob.value,
      "child_1_name": controlsNewFleetPersonalDetails.child_1_name.value,
      "child_1_dob": controlsNewFleetPersonalDetails.child_1_dob.value,
      "child_2_name": controlsNewFleetPersonalDetails.child_2_name.value,
      "child_2_dob": controlsNewFleetPersonalDetails.child_2_dob.value,
      "profile_picture": controls.profile_picture.value,
      "selfie_with_fleet_owner": controls.selfie_with_fleet_owner.value,
      "fleet_office_inside_photo": controls.fleet_office_inside_photo.value,
      "fleet_office_outside_photo": controls.fleet_office_outside_photo.value,
      "is_draft": is_draft,
      "business_related_detail": {},
      "is_prospective": controlsNewFleetBusinessDetail.is_prospective.value,
      "sap_id": controlsNewFleetBusinessDetail.sap_id.value,
      "communication_address": controlsNewFleetCommunicationDetail.communication_address.value,
      "communication_state": controlsNewFleetCommunicationDetail.communication_state.value,
      "communication_city": controlsNewFleetCommunicationDetail.communication_city.value,
      "communication_pin_code": controlsNewFleetCommunicationDetail.communication_pin_code.value
    }
    if (is_draft) {
      reqData.prospective_status = null;
    } else {
      reqData.prospective_status = 'pending';
    }
    if (controlsNewFleetPersonalDetails.languages.value && controlsNewFleetPersonalDetails.languages.value.length > 0) {
      controlsNewFleetPersonalDetails.languages.value.forEach(element => {
        reqData.languages.push(element.label);
      });
    }
    return reqData;
  }
  getReqVehicleDetail = (vehicleData) => {
    if (vehicleData.vehicles && Object.keys(vehicleData.vehicles).length > 0) {
      vehicleData.vehicles.forEach(element => {

      });
    }
  }
  updateBusinessRelatedDetails = async () => {
    if (this.refs.refVehicleDetail && this.refs.refVehicleDetail.state) {
      let frontRearData = this.refs.refVehicleDetail.state.frontRearData;
      let bias_radial_tyres = this.refs.refVehicleDetail.state.controls.bias_radial_tyres;
      let resFrontData = {
        bus: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          bias_radial_count: {},
          business_related_detail: []
        },
        truck: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          bias_radial_count: {},
          business_related_detail: []
        },
        lcv: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        },
        scv: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        },
        icv: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        },
        pickup: {
          vehicle_type_id: '',
          fleet_id: '',
          temp_id: '',
          business_related_detail: []
        }
      };
      if (frontRearData && Object.keys(frontRearData).length > 0) {
        Object.keys(frontRearData).forEach((key, i) => {
          frontRearData[key].forEach(element => {
            if (element.fleet_id) {
              resFrontData[key].fleet_id = element.fleet_id;
            }
            if (element.temp_id) {
              resFrontData[key].temp_id = element.temp_id;
            }
            if (element.vehicle_type_id) {
              resFrontData[key].vehicle_type_id = element.vehicle_type_id;
            }
            if (element.vehicle_type.value) {
              resFrontData[key].vehicle_type = element.vehicle_type.value;
            }
            let brand = element.brand.value;
            if (element.brand.value && element.brand.value.toLowerCase() === 'jk tyre') {
              brand = "JK Tyre";
            } else if (element.brand.value && element.brand.value.toLowerCase() === 'vikrant') {
              brand = "Vikrant";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'apollo') {
              brand = "Apollo";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'mrf') {
              brand = "Mrf";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'ceat') {
              brand = "Ceat";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'contil') {
              brand = "Contil";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'birla') {
              brand = "Birla";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'bkt') {
              brand = "Bkt";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'bridgestone') {
              brand = "Bridgestone";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'chalanger') {
              brand = "Chalanger";
            }
            else if (element.brand.value && element.brand.value.toLowerCase() === 'michelin') {
              brand = "Michelin";
            }
            resFrontData[key].business_related_detail.push({
              construction: element.construction.value,
              size: element.size.value,
              brand: brand,
              pattren: element.pattren.value,
              tyres: element.tyres.value ? parseInt(element.tyres.value) : 0,
              brand_id: element.brand_id.value ? element.brand_id.value : '',
              type: element.type.value ? element.type.value : ''
            })
          });
        });
      }
      let invalidCountError = {
        truck: {
          message: '',
          isInValid: false
        },
        bus: {
          message: '',
          isInValid: false
        },
        lcv: {
          message: '',
          isInValid: false
        },
        scv: {
          message: '',
          isInValid: false
        },
        icv: {
          message: '',
          isInValid: false
        },
        pickup: {
          message: '',
          isInValid: false
        }
      };
      if (resFrontData.truck.business_related_detail.length > 0) {
        resFrontData.truck.bias_radial_count = bias_radial_tyres.truck;
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.truck);
        if (resBusinessRelated !== true) {
          invalidCountError.truck.isInValid = true;
          invalidCountError.truck.message = resBusinessRelated;
        }
      }
      if (resFrontData.bus.business_related_detail.length > 0) {
        resFrontData.bus.bias_radial_count = bias_radial_tyres.bus;
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.bus);
        if (resBusinessRelated !== true) {
          invalidCountError.bus.isInValid = true;
          invalidCountError.bus.message = resBusinessRelated;
        }
      }
      if (resFrontData.scv.business_related_detail.length > 0) {
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.scv);
        if (resBusinessRelated !== true) {
          invalidCountError.scv.isInValid = true;
          invalidCountError.scv.message = resBusinessRelated;
        }
      }
      if (resFrontData.icv.business_related_detail.length > 0) {
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.icv);
        if (resBusinessRelated !== true) {
          invalidCountError.icv.isInValid = true;
          invalidCountError.icv.message = resBusinessRelated;
        }
      }
      if (resFrontData.pickup.business_related_detail.length > 0) {
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.pickup);
        if (resBusinessRelated !== true) {
          invalidCountError.pickup.isInValid = true;
          invalidCountError.pickup.message = resBusinessRelated;
        }
      }
      if (resFrontData.lcv.business_related_detail.length > 0) {
        let resBusinessRelated = await this.proceedToUpdateBusinessRelatedDetail(resFrontData.lcv);
        if (resBusinessRelated !== true) {
          invalidCountError.lcv.isInValid = true;
          invalidCountError.lcv.message = resBusinessRelated;
        }
      }
      this.inValidCountVehicleDetailError(invalidCountError);
      return invalidCountError;
    }
  }

  proceedToUpdateBusinessRelatedDetail = async (obj) => {

    try {
      this.setState({
        isLoading: true
      })
      const { data } = await FleetService.updateBusinessRelatedDetails(obj);

      this.setState({
        isLoading: false
      })
      if (data.success) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      this.setState({
        isLoading: false
      })
      return e.response.data.error[0].message;
    }
  }

  inValidCountVehicleDetailError = (obj) => {
    if (this.refs.refVehicleDetail) {
      this.refs.refVehicleDetail.inValidCountVehicleDetailError(obj);
    }
  }



  submitToZMFM = async (is_draft = true) => {


    if (!is_draft) {
      if (!this.checkAllValidation()) {
        return;
      }
      if (this.childNewFleetBusinessDetail.current.state.controls.is_prospective.value) {
        if (!this.refs.refCountVehicleDetail.handleValition()) {
          return
        }
        // if (!this.refs.refVehicleDetail.checkAllDataValidationFront()) {
        //   return
        // }
      }
    } else {
      if (!this.childNewFleetBusinessDetail.current.saveDraftValidation(true)) {
        this.scrollTo('form-business-detail');
        return
      }
    }


    // let invalidCountError = await this.updateBusinessRelatedDetails();
    // if (invalidCountError.truck.isInValid || invalidCountError.bus.isInValid || invalidCountError.lcv.isInValid ||
    //   invalidCountError.scv.isInValid || invalidCountError.icv.isInValid || invalidCountError.pickup.isInValid) {
    //   return
    // }


    let reqData = this.getReqData(is_draft);
    if (this.state.fleetByIdData && this.state.fleetByIdData.uuid) {
      reqData.uuid = this.state.fleetByIdData.uuid;
      this.updateFleetData(reqData)
      return;
    }

    this.setState({ isLoading: true });
    NewFleetService.addInviteFleet(reqData)
      .then(data => {
        if (data.data) {
          swal({
            title: 'Congratulations !',
            text: data.data.message,
            icon: 'success',
            type: 'success',
          }).then(value => {
            if (this.state.userDetail && !this.state.userDetail.temp_fleet) {
              this.redirectToOnFleetReg();
            }
          });
        }
        this.setState({ isLoading: false });
      })
      .catch(e => {
        if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
          ModalService.openAlert(e.response.data.error[0].message, '', 'error');
        }
        this.setState({ isLoading: false });
      });
  }

  getAMSM = async () => {
    try {
      const { data } = await NewFleetService.getAMSM(this.state.region_id ? this.state.region_id : this.state.userDetail.region_id);
      if (data && data.data) {
        this.setState({
          salesManagerData: data.data[0].region_manager,
          areaSalesManagerData: data.data[0].area_manager
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  getDepot = async () => {
    try {
      const { data } = await NewFleetService.getDepot(this.state.region_id ? this.state.region_id : this.state.userDetail.region_id);
      if (data && data.data) {
        this.setState({
          depotData: data.data
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  checkAllValidation() {
    let form1 = true; let form2 = true; let form3 = true; let form4 = true, form5 = true,
      form6 = true, form7 = true;

    if (!this.childNewFleetBusinessDetail.current.handleValidation(true)) {
      form1 = false;
    }
    if (!this.childNewFleetPrimaryContactDetail.current.handleValidation(true)) {
      form2 = false;
    }
    if (!this.childNewFleetPersonalDetails.current.handleValidation(true)) {
      form3 = false;
    }
    if (!this.childNewFleetBusinessDetail.current.state.controls.is_prospective.value) {
      if (!this.handleValidation(true)) {
        form4 = false;
      }
    }
    if (!this.childNewFleetCommunicationDetail.current.handleValidation(true)) {
      form5 = false;
    }
    if (!this.childNewFleetBusinessDetail.current.state.controls.is_prospective.value) {
      if (!this.refs.refCountVehicleDetail.handleValition()) {
        form6 = false;
      }
    }
    if (!this.childNewFleetBusinessDetail.current.state.controls.is_prospective.value) {
      // if (!this.refs.refVehicleDetail.checkAllDataValidationFront()) {
      //   form7 = false;
      // }
    }
    if (form4 === false) {
      this.scrollTo('form-images-detail');
    } else if (form1 === false) {
      this.scrollTo('form-business-detail');
    } else if (form2 === false) {
      this.scrollTo('form-primary-detail');
    } else if (form5 === false) {
      this.scrollTo('form-communication-detail');
    } else if (form3 === false) {
      this.scrollTo('form-personal-detail');
    } else if (form6 === false) {
      this.scrollTo('form-vehcicle-count-detail');
    } else if (form7 === false) {
      this.scrollTo('form-vehcicle-detail');
    }

    return !!(form1 === true && form2 === true && form3 === true && form4 === true && form5 === true &&
      form6 === true && form7 === true);
  }

  fileInputChange = (type) => {
    if (type === 'fileInputUploadSelfie') {
      this.fileInputUploadSelfie.click();
    } else if (type === 'fileInputUploadFleetOfficeInside') {
      this.fileInputUploadFleetOfficeInside.click();
    } else if (type === 'fileInputUploadFleetOficeOuside') {
      this.fileInputUploadFleetOficeOuside.click();
    }

  }

  redirectToOnFleetReg = () => {
    this.props.history.push('/new-fleet-registration');
  }

  inviteFleetOpen = () => {
    let data = {};
    if (this.childNewFleetBusinessDetail.current) {
      data = {
        owner_name: this.childNewFleetBusinessDetail.current.state.controls.owner_name.value,
        mobile_number: this.childNewFleetBusinessDetail.current.state.controls.mobile_number.value,
        company_name: this.childNewFleetBusinessDetail.current.state.controls.company_name.value,
      }
    }
    this.refs.childInviteFleet.toggle(data);
  }

  closeInviteFleet = (id) => {
    if (id) {
      this.getNewFleetsById(id)
    }
  }

  scrollTo(id) {
    var scroller = Scroll.scroller;
    scroller.scrollTo(id, {
      duration: 1000,
      delay: 100,
      smooth: "easeInOutQuint",
      offset: -80
    });
  }

  changeDesignation = (designation) => {
    this.childNewFleetPrimaryContactDetail.current.setDesignation(designation);
  }

  changeFleetRegType = (is_prospective) => {
    this.childNewFleetPrimaryContactDetail.current.changeFleetRegType(is_prospective);
    this.childNewFleetPrimaryContactDetail.current.handleValidation(false);
    this.childNewFleetPersonalDetails.current.changeFleetRegType(is_prospective);
    this.childNewFleetPersonalDetails.current.handleValidation(false);
    this.childNewFleetCommunicationDetail.current.changeFleetRegType(is_prospective);
    this.childNewFleetCommunicationDetail.current.handleValidation(false);
    let { controls } = this.state;
    controls.is_prospective.value = is_prospective;
    controls.selfie_with_fleet_owner.showErrorMsg = false;
    controls.selfie_with_fleet_owner.valid = true;
    controls.fleet_office_inside_photo.showErrorMsg = false;
    controls.fleet_office_inside_photo.valid = true;
    controls.fleet_office_outside_photo.showErrorMsg = false;
    controls.fleet_office_outside_photo.valid = true;
    this.setState({
      controls
    })
  }


  openAddEditVehicle = (type, isAddVehicleDetail) => {
    let { isOpenAddEditVehicle } = this.state;
    this.setState({
      isOpenAddEditVehicle: !isOpenAddEditVehicle,
      addEditVehicleType: type,
      isAddVehicleDetail: isAddVehicleDetail
    });
  }

  closeSideBarAddEditVehicle = () => {
    let { isOpenAddEditVehicle } = this.state;
    this.setState({
      isOpenAddEditVehicle: !isOpenAddEditVehicle
    })
  }

  submitVehclies = (data) => {
    let { vehicleData } = this.state;
    if (Object.keys(data).length > 0) {
      vehicleData = data;
    } else {
      vehicleData = {};
    }
    this.setState({
      vehicleData: vehicleData,
      isOpenAddEditVehicle: false
    })
    this.getFleetData();
    this.getBusinessRelatedDetail();
    //this.refs.refCountVehicleDetail.setData(vehicleData);
    //this.refs.refVehicleDetail.setData(vehicleData);
    this.scrollTo('VehicleDetail');
  }

  render() {
    const { controls, showBuildMyFleet, isListSubsidiaries,
      fleetByIdData,
      // userDetail, vehicleData, activeFragment, isFleeData
    } = this.state;
    const {
      truck,
      bus,
      // scv,
      // lcv,
    } = controls;

    return (
      <div id="profile" className={this.state.userDetail && this.state.userDetail.temp_fleet ? 'padding-15px-15px-0' : ''}>
        {
          this.stateAddEditSubsidiaries.addEditSubsidiaries && this.stateAddEditSubsidiaries.addEditSubsidiaries.length > 0 &&
          <Sidebar
            sidebar={<>
              <div className="drawer-header">
                {
                  this.state.isNotAddEditSubsidaries ? <span className="drawer-title">Subsidiaries Detail</span> :
                    <span className="drawer-title">{this.state.isAddSubsidiaries ? 'Add' : 'Edit'} Subsidiaries</span>
                }
                <img className="cursor-pointer" src="images/close.svg" alt='close' onClick={() => { this.onCloseSidebar(); }} />
              </div>
              <hr style={{ border: 'solid 1px #ced4da' }} />
              <AddEditSubsidiaries
                editSubsidiariesIndex={this.state.editSubsidiariesIndex}
                addEditSubsidiaries={Object.assign([], this.stateAddEditSubsidiaries.addEditSubsidiaries)}
                isAddSubsidiaries={this.state.isAddSubsidiaries}
                addSubsidiaries={this.addSubsidiaries} ref="childAddEditSubsidiaries"
                listSubsidiaries={[...this.stateAddEditSubsidiaries.addEditSubsidiaries]}
                editSubsidiaries={this.editSubsidiaries}
                removeSubsidiaries={this.removeSubsidiaries}
                temp_id={this.state.uuid}
                from='enroll-new-fleet' />
            </>}
            open={this.state.sidebarOpen}
            sidebarClassName={this.state.userDetail && this.state.userDetail.temp_fleet ? 'subsdiaries-sidebar top-0px height-100-percntage' : 'subsdiaries-sidebar'}
            pullRight
            styles={{ sidebar: { background: 'white', height: '90%', top: '60px' } }}
          />
        }

        {
          this.state.isOpenAddEditVehicle &&
          <Sidebar
            sidebar={
              <AddEditFleetVehicle
                addEditVehicleType={this.state.addEditVehicleType}
                vehicleData={this.state.vehicleData}
                vehicle_type={this.state.addEditVehicleType}
                closeSideBar={this.closeSideBarAddEditVehicle}
                submitVehclies={this.submitVehclies}
                uuid={this.state.uuid}
                isAddVehicleDetail={this.state.isAddVehicleDetail}
                temp_fleet={this.state.userDetail && this.state.userDetail.temp_fleet ? true : false}
                from={this.state.userDetail && this.state.userDetail.temp_fleet ? 'on-boarding' : 'enroll-new-fleet'} />
            }
            open={this.state.isOpenAddEditVehicle}
            sidebarClassName="subsdiaries-sidebar"
            pullRight
            styles={{ sidebar: { background: 'white', height: '100%', width: '40%' } }}
          />
        }

        {
          this.state.userDetail && !this.state.userDetail.temp_fleet && !showBuildMyFleet && <Row>
            <Col>
              <div style={{ display: 'flex' }}>
                <span onClick={() => { this.redirectToOnFleetReg() }} className="select-vehicle-label" style={{ color: '#545cd8', cursor: 'pointer' }}>New fleet registration</span>
                &nbsp;&nbsp;
                <FontAwesomeIcon icon={faAngleRight} style={{ fontSize: '26px', cursor: 'pointer', marginTop: '-5px' }} color="#fdbb1f" />
                &nbsp;&nbsp;
                <span className="Offtake-Entry---Invo">Enroll New Fleet</span>
              </div>
            </Col>
          </Row>
        }
        {
          this.state.userDetail && this.state.userDetail.temp_fleet && !showBuildMyFleet &&
          <>
            <Row style={{ marginBottom: '10px' }}>
              <Col xl="12" xs="12" md="12">
                <div className="text-align-right" >
                  <span className="offtake-title" style={{ float: 'left' }}>Enroll New Fleet</span>
                </div>
              </Col>
            </Row>
          </>
        }

        <>
          {
            showBuildMyFleet && <FleetRegistration
              buildMyFleetClick={this.buildMyFleetClick}
              truck={truck} bus={bus} updateTruckBusData={this.updateTruckBusData}
              from="enroll-new-fleet"
              temp_id={this.state.uuid}
            />
          }
        </>

        {
          <div className={showBuildMyFleet ? 'hidden' : ''}>
            {
              this.state.isLoading && <CustomSpinner />
            }
            <Row>
              <Col xl="3" className="margin-top-10">
                <Card id="profile-detail" className={this.state.userDetail && this.state.userDetail.temp_fleet ? 'padding-bottom-35px height-100' : 'height-100'} style={{ height: 'auto', paddingBottom: '10px' }}>
                  <CardBody style={{ paddingBottom: '0px' }}>
                    <Row>
                      <Col className="text-align-center">
                        <span className="Add-Profile-Photo">
                          Add Profile Photo
                        </span>
                        <br />

                        {/* <Ionicon icon="md-create" fontSize="24px" color="#fdbb1f" onClick={this.openRequestDetailModal} /> */}
                      </Col>
                    </Row>

                    <Row style={{ marginTop: '10px' }} id="form-images-detail">
                      <Col className="text-align-center">
                        {!controls.profile_picture.value && <img src="images/Web_Avatar.svg" height="50px" width="auto" className="profile-image" alt="" />}
                        {controls.profile_picture.value && <img src={controls.profile_picture.value} height="50px" width="auto" className="profile-image" alt="" />}
                        {/* {this.state.isImageUpdating && <Spinner size="sm" color="primary" className="profile-spinner" />} */}
                        {fleetByIdData && (fleetByIdData.is_draft || fleetByIdData.is_prospective) &&
                          <div className="create-icon-con">
                            <label className="profile-image-camera-side">
                              <div className="edit-icon">
                                <Ionicon icon="md-camera" fontSize="24px" color="#fff" />
                              </div>
                              {/* <img src="images/profile.svg" alt="profile image" className="profile-upload-image-icon"></img> */}
                              <input accept="image/*" type="file" className="visibility-hidden width-0"
                                onChange={(e) => { this.uploadFleetDoc(e, 'profile') }} />
                            </label>
                          </div>
                        }
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                {
                  isListSubsidiaries && <div id="list-subsidiaries">
                    <ListSubsidiaries
                      listSubsidiaries={Object.assign([], this.stateAddEditSubsidiaries.addEditSubsidiaries)}
                      removeSubsidiaries={this.removeSubsidiaries}
                      addMoreSubsidiaries={this.onSetSidebarOpen}
                      is_draft={(fleetByIdData.is_draft || fleetByIdData.is_prospective) ? false : true}
                      editSubsidiaries={this.editSubsidiaries} />
                  </div>
                }
                {
                  this.state.userDetail && !this.state.userDetail.temp_fleet && <div>
                    <br />
                    <span className="Add-Profile-Photo">Upload Photos</span><br />
                    {
                      this.state.userDetail && !this.state.userDetail.temp_fleet &&
                      <>
                        {
                          !controls.selfie_with_fleet_owner.value &&
                          <>
                            <div className="subsidiaries-list-warpp d-flex-row cursor-pointer" style={{ minHeight: '55px', marginTop: '10px' }}
                              onClick={() => this.fileInputChange('fileInputUploadSelfie')}>
                              <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                <Ionicon icon="md-camera" fontSize="24px" color="#fdbb1f" />
                                <input type="file" accept="image/*" className="visibility-hidden width-0" ref={ref => this.fileInputUploadSelfie = ref}
                                  onChange={(e) => { this.uploadFleetDoc(e, 'fileInputUploadSelfie') }} />
                              </div>
                              <span className="Upload-selfie-with-f" style={{ marginLeft: '10px', marginTop: 'auto', marginBottom: 'auto' }}>Upload selfie with fleet owner
                                {/* {!controls.is_prospective.value && <span className="required-field">*</span>} */}
                              </span>
                            </div>
                            {!controls.selfie_with_fleet_owner.showErrorMsg && controls.selfie_with_fleet_owner.isUploadedImage && <span style={{ color: 'green' }}>Selfie with fleet owner photo uploaded.</span>}
                            {/* {controls.selfie_with_fleet_owner.showErrorMsg && <div className="error">*Please upload selfie with fleet owner.</div>} */}
                          </>
                        }

                        {
                          controls.selfie_with_fleet_owner.value &&
                          <>
                            <Col className="text-align-left subsidiaries-list-warpp" xl="12" md="12" xs="12" style={{ marginTop: '10px' }}>
                              <Label className="text-align-left">Upload selfie with fleet owner{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                              {!controls.selfie_with_fleet_owner.value && <img src="images/cam_placeholder.png" height="140px" width="140px" className="profile-image" alt=""
                                style={{ borderRadius: '0' }} />}
                              {controls.selfie_with_fleet_owner.value && <img src={controls.selfie_with_fleet_owner.value} height="130px" width="auto"
                                className="profile-image uploaded-fleet-img" alt="" style={{ borderRadius: '0' }} />}
                              {
                                (fleetByIdData.is_draft || fleetByIdData.is_prospective) &&
                                <div className="create-icon-con text-align-center edit-fleet-img-icon">
                                  <label className="profile-image-camera-side">
                                    <div className="edit-icon" style={{ backgroundColor: 'inherit' }}>
                                      <Ionicon icon="md-create" fontSize="24px" color="#fff" />
                                    </div>

                                    <input accept="image/*" type="file" className="visibility-hidden width-0" onChange={(e) => { this.uploadFleetDoc(e, 'fileInputUploadSelfie') }} />
                                  </label>
                                </div>
                              }
                              {controls.selfie_with_fleet_owner.showErrorMsg && <div className="error error-message-new-fleet-images text-align-left">*Please upload selfie with fleet owner.</div>}
                            </Col>
                          </>
                        }
                      </>
                    }
                    {
                      !controls.fleet_office_inside_photo.value &&
                      <>
                        <div className="subsidiaries-list-warpp d-flex-row cursor-pointer" style={{ minHeight: '55px', marginTop: '10px' }}
                          onClick={() => this.fileInputChange('fileInputUploadFleetOfficeInside')}>
                          <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                            <Ionicon icon="md-camera" fontSize="24px" color="#fdbb1f" />
                          </div>
                          <span className="Upload-selfie-with-f" style={{ marginLeft: '10px', marginTop: 'auto', marginBottom: 'auto' }}>Upload fleet office - Inside Photo</span>
                          <input type="file" accept="image/*" className="visibility-hidden width-0" ref={ref => this.fileInputUploadFleetOfficeInside = ref}
                            onChange={(e) => { this.uploadFleetDoc(e, 'fileInputUploadFleetOfficeInside') }} />
                        </div>
                        {!controls.fleet_office_inside_photo.showErrorMsg && controls.fleet_office_inside_photo.isUploadedImage && <span style={{ color: 'green' }}>Fleet office - Inside Photo uploaded.</span>}
                        {controls.fleet_office_inside_photo.showErrorMsg && <div className="error">*Please upload fleet office - inside Photo.</div>}
                      </>
                    }
                    {
                      controls.fleet_office_inside_photo.value &&
                      <Col className="text-align-left subsidiaries-list-warpp" xl="12" md="12" xs="12">
                        <Label className="text-align-left">Upload fleet office - Inside Photo</Label>
                        {!controls.fleet_office_inside_photo.value && <img src="images/cam_placeholder.png" height="130px" width="auto" className="profile-image" alt="" style={{ borderRadius: '0', height: "140px", width: "140px" }} />}
                        {controls.fleet_office_inside_photo.value && <img src={controls.fleet_office_inside_photo.value} className="profile-image uploaded-fleet-img" alt="" />}
                        {
                          (fleetByIdData.is_draft || fleetByIdData.is_prospective) && <div className="create-icon-con text-align-center edit-fleet-img-icon">
                            <label className="profile-image-camera-side">
                              <div className="edit-icon" style={{ backgroundColor: 'inherit' }}>
                                <Ionicon icon="md-create" fontSize="24px" color="#fff" />
                              </div>
                              <input accept="image/*" type="file" className="visibility-hidden width-0" onChange={(e) => { this.uploadFleetDoc(e, 'fileInputUploadFleetOfficeInside') }} />
                            </label>
                          </div>
                        }
                        {controls.fleet_office_inside_photo.showErrorMsg && <div className="error error-message-new-fleet-images">*Please upload fleet office - inside Photo.</div>}
                      </Col>
                    }
                    {
                      !controls.fleet_office_outside_photo.value &&
                      <>
                        <div className="subsidiaries-list-warpp d-flex-row cursor-pointer" style={{ minHeight: '55px', marginTop: '10px' }}
                          onClick={() => this.fileInputChange('fileInputUploadFleetOficeOuside')}>
                          <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                            <Ionicon icon="md-camera" fontSize="24px" color="#fdbb1f" />
                          </div>
                          <span className="Upload-selfie-with-f" style={{ marginLeft: '10px', marginTop: 'auto', marginBottom: 'auto' }}>Upload fleet office - Outside Photo</span>
                          <input type="file" accept="image/*" className="visibility-hidden width-0" ref={ref => this.fileInputUploadFleetOficeOuside = ref}
                            onChange={(e) => { this.uploadFleetDoc(e, 'fileInputUploadFleetOficeOuside') }} />
                        </div>
                        {!controls.fleet_office_outside_photo.showErrorMsg && controls.fleet_office_outside_photo.isUploadedImage && <span style={{ color: 'green' }}>Fleet office - Outside Photo uploaded.</span>}
                        {controls.fleet_office_outside_photo.showErrorMsg && <div className="error">*Please upload fleet office - outside Photo.</div>}
                      </>
                    }
                    {
                      controls.fleet_office_outside_photo.value && <Col className="text-align-left subsidiaries-list-warpp" xl="12" md="12" xs="12">
                        <Label className="text-align-left">Upload fleet office - Outside Photo</Label>
                        {!controls.fleet_office_outside_photo.value && <img src="images/cam_placeholder.png" height="130px" width="auto" className="profile-image" alt="" style={{ borderRadius: '0', height: "140px", width: "140px" }} />}
                        {controls.fleet_office_outside_photo.value && <img src={controls.fleet_office_outside_photo.value} className="profile-image uploaded-fleet-img" alt='uploaded-fleet-img' />}
                        {
                          (fleetByIdData.is_draft || fleetByIdData.is_prospective) &&
                          <div className="create-icon-con text-align-center edit-fleet-img-icon">
                            <label className="profile-image-camera-side">
                              <div className="edit-icon" style={{ backgroundColor: 'inherit' }}>
                                <Ionicon icon="md-create" fontSize="24px" color="#fff" />
                              </div>

                              <input accept="image/*" type="file" className="visibility-hidden width-0" onChange={(e) => { this.uploadFleetDoc(e, 'fileInputUploadFleetOficeOuside') }} />
                            </label>
                          </div>
                        }
                        {controls.fleet_office_outside_photo.showErrorMsg && <div className="error error-message-new-fleet-images">*Please upload fleet office - outside Photo.</div>}
                      </Col>
                    }
                  </div>
                }


              </Col>
              <Col xl="9" className="margin-top-10">
                <Row id="form-business-detail">
                  <Col>
                    <NewFleetBusinessDetail
                      ref={this.childNewFleetBusinessDetail}
                      userDetail={this.state.userDetail}
                      salesManagerData={this.state.salesManagerData}
                      areaSalesManagerData={this.state.areaSalesManagerData}
                      depotData={this.state.depotData}
                      fleet_manager={this.state.fleet_manager}
                      fleet_manager_name={this.state.fleet_manager_name}
                      fleetByIdData={fleetByIdData}
                      changeDesignation={this.changeDesignation}
                      changeFleetRegType={this.changeFleetRegType}
                    />
                  </Col>
                </Row>
                <br />
                <Row id="form-primary-detail">
                  <Col>
                    <NewFleetPrimaryContactDetail
                      ref={this.childNewFleetPrimaryContactDetail}
                      NewFleetBusinessDetail={this.childNewFleetBusinessDetail}
                      fleetByIdData={fleetByIdData}
                    />
                  </Col>
                </Row>
                <br />
                <Row id="form-communication-detail">
                  <Col>
                    <NewFleetCommunicationDetail
                      ref={this.childNewFleetCommunicationDetail}
                      NewFleetBusinessDetail={this.childNewFleetBusinessDetail}
                      fleetByIdData={fleetByIdData} />
                  </Col>
                </Row>
                <br />
                <Row id="form-personal-detail">
                  <Col>
                    <NewFleetPersonalDetails
                      ref={this.childNewFleetPersonalDetails}
                      NewFleetBusinessDetail={this.childNewFleetBusinessDetail}
                      fleetByIdData={fleetByIdData} />
                  </Col>
                </Row>

                {/* <Row>
                  <Col>
                    <NewFleetBusinessRelatedDetails
                      ref={this.childNewFleetBusinessRelatedDetails}
                      fleetByIdData={fleetByIdData} />
                  </Col>
                </Row> */}
                {/* <Row
                // onClick={this.activeFragment.bind(this, 'social')}
                > */}
                {/* <Col xs="12" md="6" className="margin-top-15">
                    {
                      !isListSubsidiaries &&
                      <Button className="bottom-button" onClick={() => this.onSetSidebarOpen(true)}>
                        ADD SUBSIDIARIES
                      </Button>
                    }
                  </Col> */}
                {/* <Col xs="12" md="6" className="margin-top-15">
                    {
                      !isFleeData &&
                      <Button onClick={(e) => this.buildMyFleetClick(true)} className="bottom-button">
                        BUILD FLEET
                    </Button>
                    }
                  </Col> */}
                {/* </Row> */}
                <div style={{ padding: '10px' }}>
                  <Row id="form-vehcicle-count-detail">
                    <VehicleCountDeatil
                      ref="refCountVehicleDetail"
                      uuid={this.state.uuid}
                      deleteFleetVehicle={this.deleteFleetVehicle}
                      openAddEditVehicle={(type, isAddVehicle) => this.openAddEditVehicle(type, isAddVehicle)} />
                  </Row>
                  <br />
                  <Row id="form-vehcicle-detail">
                    <div id="VehicleDetail" className="w-100">
                      {/* <VehicleDetail
                        fleetByIdData={fleetByIdData}
                        ref="refVehicleDetail"
                        vehicleData={this.state.vehicleData} /> */}
                    </div>
                  </Row>
                </div>
                {/* <Row
                  id="build-my-fleet"
                  onClick={this.activeFragment.bind(this, 'fleet')}
                >
                  <Col>
                    <EditFleetDetail
                      className={activeFragment === 'fleet' ? 'card-yellow-border' : ''}
                      truck={truck}
                      bus={bus}
                      scv={scv}
                      lcv={lcv}
                      handleFleetSave={this.handleFleetSave}
                      makeEditActiveFleet={this.makeEditActiveFleet}
                      handleInputChange={this.handleInputChange}
                      activeFragment={this.activeFragment}
                      buildMyFleetClick={this.buildMyFleetClick}
                      isFleeData={isFleeData}
                      from="enroll-fleet"
                      is_draft={fleetByIdData.is_draft}
                    />
                  </Col>
                </Row> */}

              </Col>
              {
                fleetByIdData && (fleetByIdData.is_draft || fleetByIdData.is_prospective) && !this.state.userDetail.temp_fleet && <Col className="text-align-right" style={{ marginTop: '20px' }}>
                  {this.state.userDetail && this.state.userDetail.type && this.state.userDetail.type === Roles.FLEET_MANAGER_ROLE && <> <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => { this.inviteFleetOpen() }}>Invite Fleet</Button>&nbsp;&nbsp;</>}
                  <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => this.submitToZMFM(true)} style={{ width: 'auto' }}>Save As Draft</Button>&nbsp;&nbsp;
                  <Button className="mb-1 mr-1 btn-pill action-button font-weight-bold" color="warning" onClick={() => { this.submitToZMFM(false); }}>Submit to ZMFM For Approval</Button>
                </Col>
              }
              {
                fleetByIdData && fleetByIdData.is_draft && this.state.userDetail.temp_fleet &&
                <Col className="text-align-right" style={{ marginTop: '20px' }}> <Button className="mb-1 mr-1 btn-pill action-button font-weight-bold" color="warning" onClick={() => { this.submitToZMFM(true); }}>Submit</Button></Col>
              }
            </Row>
            <br />
          </div>}
        <InviteFleet ref="childInviteFleet"
          uuid={this.state.uuid}
          from="enroll-new-fleet"
          fleetByIdData={this.state.fleetByIdData}
          getEnrollFleetReqData={this.getReqData}
          setBuinesssDetailFromInviteFleet={this.setBuinesssDetailFromInviteFleet}
          closeModal={this.closeInviteFleet}
        />
        {
          this.state.userDetail && this.state.userDetail.temp_fleet &&
          <div className="logout" onClick={() => this.clearLocalData()}> <img src="images/logout.svg" alt="logout" /></div>
        }
      </div >
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setUserDetail: user => dispatch(setUserDetail(user)),
  isProfileUpdate: bool => dispatch(isProfileUpdate(bool))
});


const mapStateToProp = state => ({
  // userDetail: state.User.user,
});

export default connect(mapStateToProp, mapDispatchToProps)(EnrollNewFleet);


// export default Profile;